export const EXISTING_SCENARIO_SCROLLABLE_TARGET = 'existing-scenario-scroll';
export const EXISTING_SCENARIO_SEARCH_FIELD_NAME = 'existing-scenario-search';
export const EXISTING_SCENARIO_CHECKBOX_NAME_PREFIX = 'existing-scenario';
